import { render } from "./ResponsiveSubMenu.vue?vue&type=template&id=505d4448"
import script from "./ResponsiveSubMenu.vue?vue&type=script&lang=js"
export * from "./ResponsiveSubMenu.vue?vue&type=script&lang=js"
script.render = render

export default script